import script from "./CollectionItemsDescription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemsDescription.vue?vue&type=script&lang=js"
export * from "./CollectionItemsDescription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemsDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/collection-items-page/CollectionItemsDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1765496"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1765496', __exports__)) {
    api.reload('d1765496', __exports__)
  }
  
}


export default __exports__